export default "__VITE_ASSET__Ceb2rI_R__"